import React from 'react';
import { SystemText } from 'e4shared';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import PageHeader from 'components/general/pageHeader';
import { hasModule } from 'helpers/profile';
import { setPrismMenu } from 'actions/ui';

export const Trackers = () => {
    const dispatch = useDispatch();
    const { user } = useSelector(state => state.user);

    React.useEffect(() => {
        dispatch(setPrismMenu('Organisation'));
    }, []);

    return (
        <div>
            <PageHeader title={SystemText('Trackers/Title')} />
            <div className="trackers">
                <div className="box">
                    <Link className="btn" to="/review-tracker">
                        <i className="fa fa-gauge mr10" />
                        {SystemText('ReviewTracker/Title')}
                    </Link>
                </div>
                {hasModule(user, 'pathways') && (
                    <div className="box">
                        <Link className="btn" to="/pathway-tracker">
                            <i className="fa fa-route mr10" />
                            {SystemText('PathwayTracker/Title')}
                        </Link>
                    </div>
                )}
                <div className="box">
                    <Link className="btn" to="/learn-tracker">
                        <i className="fa fa-book-open mr10" />
                        {SystemText('LearningTracker/Title')}
                    </Link>
                </div>
                {hasModule(user, 'objectives') && (
                    <div className="box">
                        <Link className="btn" to="/tracker">
                            <i className="fa fa-circle-check mr10" />
                            {SystemText('ObjectiveTracker/Title')}
                        </Link>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Trackers;
